import { render, staticRenderFns } from "./SGPPageHeaderComponent.vue?vue&type=template&id=2618d4b8&scoped=true"
import script from "./SGPPageHeaderComponent.vue?vue&type=script&lang=js"
export * from "./SGPPageHeaderComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPPageHeaderComponent.vue?vue&type=style&index=0&id=2618d4b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2618d4b8",
  null
  
)

export default component.exports